import { LinkListItem } from '@modules/Nzo.CMS/Frontend/libraries/cmsPage/blocks/blocks.state'
import { BlocksView } from '@modules/Nzo.CMS/Frontend/libraries/cmsPage/blocks/blocks.template'
import { CMSLink } from '@modules/Nzo.CMS/Frontend/libraries/shared/cmsLink/cmsLink.state'
import { pushDatalayer } from '@shared/Frontend/seo/datalayer'
import { Clickable } from '@shared/Frontend/utils/clickable'
import React from 'react'

export const SidebarNavigationBlock: BlocksView['SidebarNavigationBlock'] = (props) => {
  const { id, title, items } = props
  if (items?.length == 0) return <></>

  return (
    <div id={id}>
      {title && <h2 className="sidebar__title title--xs">{title}</h2>}
      <ListLayout items={items} listClassName="sidebar__list" />
    </div>
  )
}

export const ListLayout = (props: { items: LinkListItem[]; listClassName?: string }) => {
  return (
    <ul className={props.listClassName}>
      {props.items.map((item, index) => {
        if (!item.link || !item.link.label || !item.link.url) return <></>
        return <ItemLayout key={index} {...item.link} />
      })}
    </ul>
  )
}

const ItemLayout = (props: CMSLink) => {
  const { label } = props
  const isActive = typeof window !== 'undefined' && window.location.pathname === props.url
  return (
    <li className={`sidebar__item ${isActive ? 'active' : ''}`.trim()}>
      <Clickable
        elementKind="link"
        styleKind="link"
        {...props}
        className="link link--filled"
        hasBlob={true}
        icon={'icon-chevron-right'}
        onClick={() => pushDatalayer({ category: 'linklist_item', label, action: 'linklist_item_click' })}
      />
    </li>
  )
}
